<template>
  <div :class="['ms-form', 'ms-form--narrow', {purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomInput
            :required="true"
            label="Название документа"
            :value="this.formData.file_name || ''"
            @change_input="(value) => onChange('file_name', value)"
        />
        <div>
          <CustomUploader :value="this.formData?.file"
                          :on-change="(value) => this.onChange('file', value)" label="Файл"/>
        </div>
      </div>
      <CustomModalFooter :btn-loading="this.loading"/>
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomUploader from "@/components/form/CustomUploader";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "add-handbook-document",
  components: {CustomInput, CustomUploader, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        file_name: '',
        file: null
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      let formData = new FormData()
      formData.append('file_name', this.formData.file_name)
      if (this.formData.file)
        formData.append('file', this.formData.file[0])
      this.loading = true
      await this.data?.onSubmit(formData)
      this.loading = false
    },
  },
}
</script>
